import { withRBAC } from "../../rbac";
import { AttendanceCreate } from "./Create";
import { AttendanceEdit } from "./Edit";
import { AttendanceList } from "./List";

export const attendance = {
  list: withRBAC(AttendanceList, "view_hr"),
  create: withRBAC(AttendanceCreate, "manage_attendance"),
  edit: withRBAC(AttendanceEdit, "manage_attendance"),
};
